import axios from 'axios';
import { API_ENDPOINT, PAGE_SIZE } from '../constants/constants';
import { getHeader } from './util';

// Receipt totals are unfiltered. Walk pages until the matching result is exhausted.
export async function fetchListPages(endpoint, filters = {}, { onProgress, trustTotalPages = true } = {}) {
  const rows = [];
  const seen = new Set();
  for (let page = 1; ; page += 1) {
    const { data } = await axios.get(API_ENDPOINT + endpoint, { ...getHeader(), params: { ...filters, page } });
    if (!Array.isArray(data.data)) throw new Error('The list response could not be read. Please try again.');
    const items = data.data;
    const pageSize = data.pageSize || data.pagination?.pageSize || PAGE_SIZE;
    let added = 0;
    items.forEach(item => {
      const id = item._id || item.silkcart_id || item.order_id;
      if (id && seen.has(String(id))) return;
      if (id) seen.add(String(id));
      rows.push(item);
      added += 1;
    });
    onProgress?.(rows.length);
    if (items.length === 0 || items.length < pageSize) break;
    const totalPages = data.pagination?.totalPages ?? data.totalPages;
    if (trustTotalPages && Number.isFinite(totalPages) && page >= totalPages) break;
    if (!added) throw new Error('The list changed while loading. Please refresh and try again.');
  }
  return rows;
}

export function dateKey(value) {
  if (!value) return '';
  if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)) return value;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  const parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Asia/Kolkata', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(date);
  const part = type => parts.find(item => item.type === type)?.value;
  return `${part('year')}-${part('month')}-${part('day')}`;
}
export function filterOrderDates(rows, { startDate, endDate, dateField = 'createdOn' }) {
  if (!startDate && !endDate) return rows;
  return rows.filter(row => {
    const key = dateKey(row[dateField]);
    return key && (!startDate || key >= startDate) && (!endDate || key <= endDate);
  });
}
export const orderParams = filters => ({ type: filters.type || '', order_id: filters.order_id || '', status: filters.status || '', companyName: filters.companyName || '', paymentStatus: filters.paymentStatus || '' });
export const numericCell = value => value === null || value === undefined || value === '' || !Number.isFinite(Number(value)) ? '' : Number(value);
